import { Business } from '../../backend/db/all-entities';
import BusinessProfileHeader from './profile-header';

export type CardRenderableBusiness = Pick<Business, 'id' | 'name' | 'logoUrl' | 'geolocations' | 'bio' | 'pricingPlan'>;

interface Props {
  business: CardRenderableBusiness;
}

const BusinessCard: React.FC<Props> = ({ business: { id, name, logoUrl, bio, pricingPlan } }) => (
  <article className='bg-gray-700 rounded-lg h-56'>
    <BusinessProfileHeader business={{ id, name, logoUrl, pricingPlan }} className='text-sm h-12 px-4' />
    <p className='mx-4 flex-grow'>{bio}</p>
    <style jsx>{`
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    `}</style>
  </article>
);

export default BusinessCard;
